export enum PaymentPlanStatusEnum {
    ACTIVE = 'active',
    HIDDEN = 'hidden',
    INACTIVE = 'inactive',
}

export const PaymentPlanStatusLabels = {
    [PaymentPlanStatusEnum.ACTIVE]: 'Ativo',
    [PaymentPlanStatusEnum.INACTIVE]: 'Inativo',
    [PaymentPlanStatusEnum.HIDDEN]: 'Oculto (não será exibido na inicialização do bot)',
}